import styled from 'styled-components';
import React, { FC } from 'react';
import { TransitionStatus } from 'react-transition-group/Transition';
import { black, boxShadow1, exactWhite } from 'utils/style/colors';

export const POPOVER_TRANSITION_DURATION = 300;

interface IPopoverWrapperProps {
  marginToTarget: number;
  arrow: boolean;
  fixTop?: number;
  $viewportFit?: boolean;
  viewportFit?: boolean;
  overflowVisible?: boolean;
}

interface IPopoverContentProps {
  arrow: boolean;
  curveBorder: boolean;
}

type PopoverTransitionProps = {
  transitionState: TransitionStatus;
};

export const PopoverTransition = styled('div')<PopoverTransitionProps>`
  opacity: 0;
  transition: opacity ${POPOVER_TRANSITION_DURATION}ms ease-in-out;
  ${(props) => {
    switch (props.transitionState) {
      case 'entering':
        return 'opacity: 1';
      case 'entered':
        return 'opacity: 1';
      case 'exiting':
        return 'opacity: 0';
      case 'exited':
        return 'opacity: 0';
      default:
        return '';
    }
  }}
`;

export const PopoverWrapper = styled('div')<IPopoverWrapperProps>`
  max-width: max(80vw, 300px);
  z-index: 20000001;
  white-space: ${({ viewportFit }) => (viewportFit ? 'normal' : 'nowrap')};
  width: ${({ viewportFit }) => (viewportFit ? 'auto' : 'max-content')};
  overflow: ${({ overflowVisible }) =>
    overflowVisible ? 'visible' : 'hidden'};
  box-shadow: ${boxShadow1};
  border-radius: 15px;
  ${({ viewportFit }) =>
    viewportFit &&
    `
    min-width: 0;
  `}
  ${(props) =>
    props.arrow &&
    `
    &[data-placement='bottom-start'] {
      margin-left: -18px;
    }
    &[data-placement*='right-'] {
      margin-top: -20px;
    }
  `}
  ${({ fixTop }) => (fixTop ? `top: ${fixTop}px !important;` : '')}
  
  ${({ marginToTarget }) => `
    &[data-placement*='bottom'] {
      margin-top: ${marginToTarget}px;
    }
    &[data-placement*='top'] {
      margin-bottom: ${marginToTarget}px;
    }
    &[data-placement*='right'] {
      margin-left: ${marginToTarget}px;
    }
    &[data-placement*='left'] {
      margin-right: ${marginToTarget}px;
    }
  `}
`;
interface Props {
  children: any;
}
const PopOverContentInside: FC<Props> = ({ children, ...props }) =>
  React.cloneElement(children, props);
export const PopoverContent = styled(
  PopOverContentInside
)<IPopoverContentProps>`
  color: ${black};
  ${(props) =>
    props.arrow &&
    `padding: 10px 20px;
    background-color: var(--exact-white);
  `};
  &[data-placement*='bottom'] {
    box-shadow: ${boxShadow1};
    min-height: 35px;
  }
  &[data-placement*='top'] {
    box-shadow: ${boxShadow1};
  }
  &[data-placement*='right'] {
    box-shadow: ${boxShadow1};
  }
  &[data-placement*='left'] {
    box-shadow: ${boxShadow1};
  }
  ${(props) => props.curveBorder && 'border-radius: 15px;'};
`;

export const PopoverArrow = styled('div')`
  position: absolute;
  display: inline-block;
  width: 14px;
  height: 14px;
  background: ${exactWhite};
  box-shadow: ${boxShadow1};
  clip-path: polygon(100% 0, 0 0, 100% 100%);
  &[data-placement*='bottom'] {
    transform: rotate(-45deg);
    top: -7px !important;
  }
  &[data-placement*='top'] {
    transform: rotate(135deg);
    bottom: -7px !important;
  }
  &[data-placement*='right'] {
    transform: rotate(225deg);
    left: -7px !important;
  }
  &[data-placement='top-start'] {
    right: 14px !important;
  }
`;
